module.exports = __webpack_public_path__ + "img/Deutsche Bank.561fd364.png";